import {SERVER_URL} from '../utils/http-request';
import {ApiService} from '../services/ApiService';

const serverApi = new ApiService(SERVER_URL);
export const {del, post, put, get, customRequest} = serverApi.exposeMethods();
